
import { functions } from "../../firebaseClient";

export async function submitDirectSealGateDecision(
  contractReviewId: string,
  actorKey: "lisa" | "irene",
  decision: "ALLOW" | "DENY",
  note?: string
) {
    const fn = functions.httpsCallable("directSealGateAction");
    try {
        const res = await fn({
            contractReviewId,
            actorKey,
            decision,
            note
        });
        return res.data;
    } catch (e: any) {
        console.error("[DirectSealGate] Call failed:", e);
        throw new Error(e.message || "Action failed");
    }
}
